<script lang="ts" setup>
import { defineAsyncComponent } from 'vue'
// components
import TheBasket from '~/components/Basket/basket-state/TheBasket.vue'

/* stores */
import { useBasketStore } from '@/store/basket/basket'
import { useMapSettingsStore } from '@/store/map-settings/map-settings'
import { useToggleStore } from '@/store/toggle/toggle'

const BasketErrorPage = defineAsyncComponent(
  () => import('@/components/Basket/basket-state/BasketErrorPage.vue'),
)
const BasketEmptyPage = defineAsyncComponent(
  () => import('@/components/Basket/basket-state/BasketEmptyPage.vue'),
)

const basketStore = useBasketStore()
const toggleStore = useToggleStore()
const mapSettingsStore = useMapSettingsStore()

const isBasketLoaded = computed(() => basketStore.isLoaded)

const isBasketDisabled = computed(
  () =>
    basketStore.basketIsDisabled || !toggleStore.featureToggle.basket_enabled,
)

const isBasketEmpty = computed(() => basketStore.basketIsEmpty)

onMounted(() => mapSettingsStore.fetchMapSettings())

usePopupFetch()
</script>

<template>
  <div
    class="basket-page"
    :class="{ 'basket-page--exist': !isBasketEmpty && !isBasketDisabled }"
  >
    <app-head title="Ваш заказ" />

    <app-progress v-if="!isBasketLoaded" :page="true" :size="100" />

    <basket-error-page v-else-if="isBasketDisabled" />

    <basket-empty-page v-else-if="isBasketEmpty" />

    <the-basket v-else />
  </div>
</template>

<style lang="scss" scoped>
.page--container {
  padding: 20px 0;
}

.basket-page {
  padding: 40px 0 60px;

  &--exist {
    background-color: $button-background;
  }

  @include media('<tablet') {
    padding: 0;
  }
}
</style>
